import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, Output, EventEmitter, ElementRef, Renderer2, HostListener } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { environment } from 'src/environments/environment';
import { AppConfigService } from './app-config.service';
import { MenuSubSideComponent } from './layout/menu/toplist/subside/subside.component';
import 'regenerator-runtime/runtime';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { LoginService } from '@serengeti/serengeti-common';
import { ChatbotDialogComponent } from '@serengeti/serengeti-chatbot';

@Component({
	selector: 'app-component-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
	@ViewChild("sidenav", { static: false }) sidenav: MatDrawer;
	@ViewChild("submenu", { static: false }) submenu: MenuSubSideComponent;

	isDragging = false;
	profile: any;

	selectedMenu: any;

	hideDropdown = true;
	numberOfNotification = 0;
	menus: any[];
	menuNavigation = '';

	selectedSubMenu: any;
	documentSideMenuWidth = '';
	chatbotBrowser = false;
	chatbotUsed;

	@Output() public sidenavToggle = new EventEmitter<any>();

	classDashboard: boolean = false;

	constructor(
		private router: Router,
		private appConfigService: AppConfigService,
		private loginService: LoginService,
		private el: ElementRef,
		private renderer: Renderer2,
		public dialog: MatDialog
	) {
		(window as any).serengetiSession = {
			id: this.loginService.getLoginId(),
			name: this.loginService.getLoginName()
		};
		this.profile = environment.profile;
		this.chatbotUsed = environment.chatbotUsed === 'true';
		this.numberOfNotification = this.appConfigService.numberOfNotification;
		this.appConfigService.numberOfNotificationSubject.subscribe((numberOfNotification: number) => {
			this.numberOfNotification = numberOfNotification;
		});
		this.menus = this.appConfigService.menus;
		this.appConfigService.menuSubject.subscribe((menus: any[]) => {
			this.menus = menus;
		});
		this.menuNavigation = environment.menuNavigation;
		document.documentElement.style.setProperty('--documentFileManagerOffset', '13');

		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				if (event.url === '/main' || event.url === '/main/(content:dashboard/list)?update=update' || event.url === '/main?returnUrl=%2F') {
					this.classDashboard = true;
				} else {
					this.classDashboard = false;
				}
			}
		})
	}

	public ngOnInit() {
		this.chatbotBrowser = this.router.url.includes('chatbot');
	}

	public ngAfterViewInit(): void {
		if (this.profile === 'staging') {
			// const dropdown = this.el.nativeElement.querySelector('.content.dropdown');
			// const dropdown = this.el.nativeElement.querySelector('.content.sidepopup');
			// const matDrawerContent = this.el.nativeElement.querySelector('.mat-drawer-content');

			// this.renderer.setStyle(dropdown, 'width', '100%');
			// this.renderer.setStyle(dropdown, 'margin-left', '0');
			// this.renderer.setStyle(dropdown, 'transform-origin', 'top left');
			// this.renderer.setStyle(matDrawerContent, 'overflow-x', 'hidden');

			// this.resizeApply();
		}
	}

	public ngOnDestroy() {
	}

	public onToggleSidenav(menu: any) {
		if (this.selectedMenu === menu) {
			this.sidenav.toggle();
		} else if (menu && !this.sidenav.opened) {
			this.sidenav.toggle();
		}
		if (this.sidenav.opened) {
			document.documentElement.style.setProperty('--documentSideMenuWidth', this.documentSideMenuWidth);
		} else {
			this.documentSideMenuWidth = document.documentElement.style.getPropertyValue('--documentSideMenuWidth');
			document.documentElement.style.setProperty('--documentSideMenuWidth', '0');
		}
		this.selectedMenu = menu;
	}

	public onOpenStateChanged($event: boolean) {
		this.submenu.triggerToggleState($event);
	}

	doHandleClick($event: any) {
		this.hideDropdown = true;
	}

	onToggleDropdown($event: any) {
		this.hideDropdown = $event.dropdownState;
	}

	public onTopMenuSelected(menu: any) {
		this.selectedMenu = menu;
		this.sidenavToggle.emit(menu);
	}

	public selectSubMenu(event) {
		this.selectedSubMenu = event;
	}

	openDialog(): void {
		if (!this.isDragging) {
			const dialog = this.dialog.open(ChatbotDialogComponent, {
				id: 'chat-bot-dialog',
				width: '90%',
				height: '90%'
			});
			dialog.afterClosed().subscribe(result => {
			});
		}
		this.isDragging = false;
	}

	dragStarted($event) {
		this.isDragging = true;
	}

	scaleTransform;
	resizeApply() {
		// const content = this.el.nativeElement.querySelector('.content.dropdown');
		// const mainContent = this.el.nativeElement.querySelector('.main.dropdown');
		const content = this.el.nativeElement.querySelector('.content.sidepopup');
		const mainContent = this.el.nativeElement.querySelector('.main.sidepopup');

		if (window.innerWidth > 800) {
			if ((content !== undefined && content !== null) && (mainContent !== undefined && mainContent !== null) && !content.getAttribute('class').includes('dashboard')) {
				//
				// this.renderer.setStyle(content, 'width', '1720.8px');
				this.renderer.setStyle(content, 'width', '1562px');

				// const desiredWidthPercentage = 90;
				const desiredWidthPercentage = 100;

				const windowWidth = window.innerWidth;

				const scaleX = (windowWidth * desiredWidthPercentage) / 100 / content.offsetWidth;
				this.scaleTransform = `scale(${scaleX})`;

				this.renderer.setStyle(content, 'transform', this.scaleTransform);
				// this.renderer.setStyle(content, 'margin-left', `${window.innerWidth * 0.05}px`);
				this.renderer.setStyle(mainContent, 'height', `${content.offsetHeight}px`);
				this.renderer.setStyle(mainContent, 'width', `${window.innerWidth}px`);
			}
		}
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: Event) {
		if (this.profile === 'staging') {
			// this.resizeApply();
		}
	}
}
